import { RequestConfig } from '~/common/services/requests';
import { AnyDocument } from '../../../../types';
import { InceptHeader } from '../../../constants/InceptHeader';
import { ConstructGet } from '../../../types/ConstructGet';
import { PaginatedResponse } from '../../../types/PaginatedResponse';
import { APPLICATION_BASE_PATH } from '../constants/applicationBasePath';

export type GetApplicationsHeaders = {
  definitionName?: string;
  workflowName?: string;
  statusDefinition?: string;
};

export const getApplications = async (
  constructGet: ConstructGet,
  params?: RequestConfig['params'],
  headers?: GetApplicationsHeaders,
): Promise<PaginatedResponse<AnyDocument[]> | undefined> =>
  constructGet(APPLICATION_BASE_PATH, {
    params,
    headers: {
      ...(headers?.definitionName
        ? { [InceptHeader.DefinitionName]: headers.definitionName }
        : {}),
      ...(headers?.workflowName
        ? { [InceptHeader.WorkflowName]: headers.workflowName }
        : {}),
      ...(headers?.statusDefinition
        ? { [InceptHeader.StatusName]: headers.statusDefinition }
        : {}),
    },
  });
